'use client'

import FaqItem from './FaqItem'
import type { FaqItemTemplate } from './FaqTemplates'

export default function FaqItemsList({
  faqItems,
}: {
  faqItems: FaqItemTemplate[]
}) {
  return (
    <>
      {faqItems.map((templatedStrings, index) => (
        <FaqItem key={index} {...templatedStrings} />
      ))}
    </>
  )
}
